<template>
  <div class="bg-white py-12 px-20">
    <a
      :href="`https://${singleLandingPage.bannerUrl}`"
      @click="updateClientClickBanner"
    >
      <img
        class="w-full object-cover h-360px"
        :src="imageURL + singleLandingPage.bannerImage"
        alt="banner"
      />
    </a>
    <div class="mt-4 border-b pb-6">
      <h1 class="text-4xl text-2d3748 font-bold">
        {{ singleLandingPage.pageName }}
      </h1>
      <small class="text-sm text-2d3748 font-medium mt-2">{{
        new Date(singleLandingPage.createdAt).toDateString()
      }}</small>
    </div>
    <div class="mt-12 flex">
      <div class="w-4/12">
        <a
          :href="`https://${singleLandingPage.url1}`"
          @click="updateClientClickURL1"
        >
          <img
            class="w-full object-cover height-cardf250"
            :src="imageURL + singleLandingPage.landingPageImage1"
            alt="banner"
          />
        </a>
      </div>
      <div class="w-8/12 p-4">
        <!-- <h2 class="text-2xl text-2d3748 font-semibold">Section</h2> -->
        <p
          class="text-md text-2d3748 font-medium editor-tagcss"
          v-html="singleLandingPage.content"
        ></p>
      </div>
    </div>
    <div class="mt-12 flex">
      <div class="w-4/12">
        <a
          :href="`https://${singleLandingPage.url2}`"
          @click="updateClientClickURL2"
        >
          <img
            class="w-full object-cover height-cardf250"
            :src="imageURL + singleLandingPage.landingPageImage2"
            alt="banner"
          />
        </a>
      </div>
      <div class="w-8/12 p-4">
        <h2 class="text-2xl text-2d3748 font-semibold">Section</h2>
        <p class="text-md text-2d3748 font-medium">
          Get a Mini Website to represent your online brand absolutely fre of
          cost! All you need to do is select a suite, add your details and go
          online. Get a Mini Website to represent your online brand absolutely
          fre of cost! All you need to do is select a suite, add your details
          and go online. Get a Mini Website to represent your online brand
          absolutely fre of cost! All you need to do is select a suite, add your
          details and go online. Get a Mini Website to represent your online
          brand absolutely fre of cost! All you need to do is select a suite,
          add your details and go online. Get a Mini Website to represent your
          online brand absolutely fre of cost! All you need to do is select a to
          represent online.
        </p>
      </div>
    </div>
    <!-- <div class="mt-8 flex">
      <div class="w-4/12">
        <img
          class="w-full object-cover height-cardf"
          src="https://nimbuscluster.blob.core.windows.net/server01/Brained/Ecom/ecom1.svg"
          alt="banner"
        />
      </div>
      <div class="w-8/12 p-4">
        <h2 class="text-2xl text-2d3748 font-semibold">Section</h2>
        <p class="text-md text-2d3748 font-medium  mt-4">
          Get a Mini Website to represent your online brand absolutely fre of
          cost! All you need to do is select a suite, add your details and go
          online. Get a Mini Website to represent your online brand absolutely
          fre of cost! All you need to do is select a suite, add your details
          and go online. Get a Mini Website to represent your online brand
          absolutely fre of cost! All you need to do is select a suite, add your
          details and go online. Get a Mini Website to represent your online
          brand absolutely fre of cost! All you need to do is select a suite,
          add your details and go online. Get a Mini Website to represent your
          online brand absolutely fre of cost! All you need to do is select a to
          represent online.
        </p>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      singleLandingPage: {},
    };
  },
  methods: {
    async loadData() {
      let filteredURL = window.document.location.href.split("=");
      const payload = {
        shortURL: filteredURL[1],
      };
      const { data } = await this.$store.dispatch(
        "landingPage/getSingle",
        payload
      );
      this.singleLandingPage = data;
      const opens = {
        id: this.singleLandingPage._id,
        clicks: this.singleLandingPage.clicks + 1,
      };
      await this.$store.dispatch("landingPage/updateOpens", opens);
    },
    async updateClientClickBanner() {
      const opens = {
        id: this.singleLandingPage._id,
        bannerUrlClicks: this.singleLandingPage.bannerUrlClicks + 1,
      };
      await this.$store.dispatch("landingPage/updateOpens", opens);
    },
    async updateClientClickURL1() {
      const opens = {
        id: this.singleLandingPage._id,
        url1Clicks: this.singleLandingPage.url1Clicks + 1,
      };
      await this.$store.dispatch("landingPage/updateOpens", opens);
    },
    async updateClientClickURL2() {
      const opens = {
        id: this.singleLandingPage._id,
        url2Clicks: this.singleLandingPage.url2Clicks + 1,
      };
      await this.$store.dispatch("landingPage/updateOpens", opens);
    },
  },
  async mounted() {
    this.loadData();
  },
  computed: {
    imageURL() {
      return process.env.VUE_APP_IMAGE_URL;
    },
  },
};
</script>
